import React, { useState, useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'
import IconText from '../IconText'
import { SessionContext } from '../../providers/SessionContextProvider'
import Modal from '../Modal'
import { Sheet } from '../../pages/StoreDetail/Menu/ProductItem/ProductOrderSheet/AllergenModal/styled'
import TimePicker from '../TimePicker'
import { HeaderSmall } from '../Text'
import usePickupTimer from '../../hooks/usePickupTimer'

function PickupTimer() {
  const { store, pickup, writeCache } = useContext(SessionContext)
  const [modalOpen, setModalOpen] = useState(false)
  usePickupTimer({ store })

  function onClick() {
    setModalOpen(true)
  }

  function onClose() {
    setModalOpen(false)
  }

  function onChange({ time, isInstantOrder = false }) {
    const updated = { time: time.toISOString(), isInstantOrder, __typename: 'Pickup' }
    writeCache({ pickup: updated })
    setModalOpen(false)
  }

  return (
    <>
      <IconText icon="clock">
        <HeaderSmall onClick={onClick} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
          <FormattedMessage id="components.OrderSummary.PickupAt" />
          {pickup && ` ${moment(pickup.time).format('HH:mm')}`}
        </HeaderSmall>
      </IconText>
      {modalOpen && (
        <Modal onClose={onClose}>
          <Sheet>
            <TimePicker
              store={store}
              onChange={onChange}
            />
          </Sheet>
        </Modal>
      )}
    </>
  )
}

export default PickupTimer
